import { Campaign, Person } from '@mui/icons-material';
import ImageModalComponent from 'components/ImageModalComponent';
import ImageSimpleColumnComponent from 'components/ImageSimpleColumnComponent';
import TableComponent, { IColumnProps } from 'components/TableComponent';
import { useEffect, useState } from 'react';
import {
  IAlarmCentralEventProps,
  IVirtualAlarmCentralProps,
} from 'services/AlarmCentralService/Virtual/types';
import { Grid2 } from '@mui/material';
import { IPaginationParams } from '../../../../services/types';
import { getStreamByEndpointAsync } from '../../../../services/Events';
import { IAlarmCentralProps } from '../../../../services/AlarmCentralService/types';
import { useGetAllAlarmCentralEventByIdCountAsync } from '../../../../services/AlarmCentralService/hooks/useMutations';

interface AlarmCentralEventsListProps {
  alarmCentral: IAlarmCentralProps | IVirtualAlarmCentralProps;
  onGetLastEvent?: (event: IAlarmCentralEventProps) => void;
}

const AlarmCentralEventsList = ({
  alarmCentral,
  onGetLastEvent,
}: AlarmCentralEventsListProps) => {
  const [isVisibleImageModal, setIsVisibleImageModal] =
    useState<boolean>(false);
  const [imageUrlToRender, setImageUrlToRender] = useState<string>('');
  const [events, setEvents] = useState<IAlarmCentralEventProps[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const handleOpenImageModal = (imageUrl: string) => {
    setIsVisibleImageModal(true);
    setImageUrlToRender(imageUrl);
  };
  const { mutateAsync: mutateGetAllAlarmCentralEventByIdCountAsync } =
    useGetAllAlarmCentralEventByIdCountAsync();

  const columns: IColumnProps[] = [
    {
      label: '',
      width: 0,
      id: 'responsibleUsername',
      render: (responsible) => {
        return (
          <>
            {responsible ? (
              <Person color="primary" />
            ) : (
              <Campaign color="error" />
            )}
          </>
        );
      },
    },
    { label: 'Descrição', id: 'description' },
    {
      id: 'image',
      label: 'Imagem',
      width: '15%',
      align: 'center',
      render: (url) => {
        return (
          <ImageSimpleColumnComponent
            url={url}
            onClick={() => handleOpenImageModal(url)}
          />
        );
      },
    },
    {
      label: 'Dispositivo',
      width: 100,
      id: 'device.name',
      align: 'center',
      render: (deviceName) => {
        return deviceName ? <>{deviceName}</> : <>-</>;
      },
    },
    { label: 'Zona', width: 100, id: 'zone', align: 'center' },
    { label: 'Conta', width: 100, id: 'account', align: 'center' },
    { label: 'Partição', width: 100, id: 'partition', align: 'center' },
    {
      label: 'Código do evento',
      width: 100,
      id: 'eventCode',
      align: 'center',
      render: (evt, index) => {
        if (events) {
          return <>{events[index]?.qualifier + evt}</>;
        }
        return <></>;
      },
    },
    {
      label: 'Responsável',
      id: 'responsibleUsername',
      width: 0,
      align: 'center',
      render: (responsible) => {
        return <>{responsible ?? 'SISTEMA'}</>;
      },
    },
    {
      label: 'Data/Hora',
      width: 100,
      id: 'createdAt',
      render: (date: any) => {
        return <>{new Date(date).toLocaleString()}</>;
      },
    },
  ];

  const streamByEndpointAsync = (pag: IPaginationParams) =>
    getStreamByEndpointAsync(
      'v1/alarmCentral' + `/${alarmCentral.id}/events`,
      setEvents,
      pag,
      undefined,
      setIsLoading,
      undefined,
      false,
    );

  useEffect(() => {
    if (onGetLastEvent && events.length > 0) onGetLastEvent(events[0]);
  }, [events]);

  useEffect(() => {
    if (alarmCentral.id) {
      streamByEndpointAsync(pagination);
      mutateGetAllAlarmCentralEventByIdCountAsync(alarmCentral.id).then(
        setTotalCount,
      );
    }
  }, [alarmCentral]);

  return (
    <Grid2 size={12} sx={{ mt: 2 }}>
      <TableComponent
        columns={columns}
        title="Últimos eventos"
        rows={events ?? []}
        totalCount={totalCount}
        // isLoading={isLoading}
        onChangePageOrRowsPerPage={(pag) => {
          streamByEndpointAsync(pag);
          setPagination(pag);
        }}
        emptyMessage="Nenhum evento encontrado"
      />
      <ImageModalComponent
        isOpen={isVisibleImageModal}
        handleClose={() => setIsVisibleImageModal(false)}
        imageUrl={imageUrlToRender}
      />
    </Grid2>
  );
};

export default AlarmCentralEventsList;
